import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const fetchNotifyUsers = async () => {
  const response = await axiosInstance.get("admin/notify-user", {
    headers,
  });
  return response.data;
};

export const deleteNotifyUser = async (id) => {
  return await axiosInstance.delete(`admin/notify-user/${id}`, { headers });
};
